import { ExportClusterUsers } from './ExportClusterUsers';
import { ExportSurveyResponses } from './ExportSurveyResponses';
import { SearchInstance } from './SearchInstance';

export type ButtonBoxProps = {
  clusters: string;
  surveys: string;
};

/**
 * @deprecated This component was migrated from Preact and should not be used or refactored.
 * It does not comply with our current architectural patterns (compound components, proper separation of concerns, etc.).
 * These legacy components will be migrated in due course.
 */
export function ButtonBox({ clusters, surveys }: ButtonBoxProps) {
  return (
    <div className="p-4">
      <div className="grid grid-cols-4 gap-4">
        <ExportClusterUsers clusters={clusters} />
        <ExportSurveyResponses surveys={surveys} />
        <SearchInstance />
      </div>
    </div>
  );
}
